$('.selectSizeBtn').on('click', function(e){
    // alert('hide');
    $('.selectSizeErrorMsg').removeClass('hide');
    $('.product-options-inner').addClass('errorClassOptionName');
    e.preventDefault();
    return false;
});


var optionSize = $('.optionSize').val();
    // alert(optionSize);

if(optionSize > 1){
  $('body').on('click', '.product-options__value', function() {
    var dataStyle = $(this).parents('.product-options__section').attr("data-style");
    if(dataStyle == "large-text"){
      $(this).parents( ".product-options-inner" ).removeClass('Size'); 
      $(this).parents( ".product-options-inner" ).removeClass( 'errorClassOptionName' );
    }else{
      $(this).parents( ".product-options-inner" ).removeClass('Style');
      $(this).parents( ".product-options-inner" ).removeClass( 'errorClassOptionName' );
    }

    if($('.Size')[0] || $('.Style')[0]){
      
    }else{
      $('.selectSizeErrorMsg').addClass('hide');
      $('.selectSizeBtn').addClass('hide');
      $('.afterSelectSize').removeClass('hide');
    }
  });
}else{
  $('body').on('click', '.product-options__value', function() {
    
    $(this).parents( ".product-options-inner" ).removeClass( 'errorClassOptionName' );
    
    // alert(optionSize);
    $('.selectSizeErrorMsg').addClass('hide');
    $('.selectSizeBtn').addClass('hide');
    $('.afterSelectSize').removeClass('hide');
  });
}

